import ApiPaymentMethods from "./apiPaymentMethods";
import RoutesPath from "./RoutesPath";
import { CONSTANTS_STRINGS } from "./strings";

export type FinalMessageType = {
  title: string;
  subtitle?: string;
  cardTitle: string;
  cardMessage: string;
};

export const FINAL_MESSAGES_MAP = {
  [RoutesPath.PAYMENT_CONFIRMED]: {
    title: CONSTANTS_STRINGS.PAYMENT_CONFIRMED_TITLE,
    cardTitle: CONSTANTS_STRINGS.PAYMENT_CONFIRMED_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.PAYMENT_CONFIRMED_CARD_MESSAGE,
  },
  [RoutesPath.CREDIT_CARD_SUCCESS]: {
    title: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_SUCESS_TITLE,
    cardTitle: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_SUCESS_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_SUCESS_CARD_MESSAGE,
  },
  [RoutesPath.CREDIT_CARD_SCHEDULED]: {
    title: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_SCHEDULED_TITLE,
    cardTitle: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_SCHEDULED_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_SCHEDULED_CARD_MESSAGE,
  },
  [RoutesPath.CREDIT_CARD_ERROR]: {
    title: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_ERROR_TITLE,
    subtitle: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_ERROR_SUBTITLE,
    cardTitle: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.CREDIT_CARD_PAYMENT_ERROR_CARD_MESSAGE,
  },
  [RoutesPath.BANK_SLIP_SUCCESS]: {
    title: CONSTANTS_STRINGS.BANK_SLIP_PAYMENT_SUCESS_TITLE,
    cardTitle: CONSTANTS_STRINGS.BANK_SLIP_PAYMENT_SUCESS_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.BANK_SLIP_PAYMENT_SUCESS_CARD_MESSAGE,
  },
  [RoutesPath.BANK_SLIP_ERROR]: {
    title: CONSTANTS_STRINGS.BANK_SLIP_PAYMENT_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.BANK_SLIP_PAYMENT_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.BANK_SLIP_PAYMENT_ERROR_CARD_MESSAGE,
  },
  [RoutesPath.BOLEPIX_SUCCESS]: {
    title: CONSTANTS_STRINGS.BOLEPIX_PAYMENT_TITLE,
    cardTitle: CONSTANTS_STRINGS.BOLEPIX_PAYMENT_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.BOLEPIX_PAYMENT_CARD_MESSAGE,
  },
  [RoutesPath.BOLEPIX_ERROR]: {
    title: CONSTANTS_STRINGS.BOLEPIX_PAYMENT_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.BOLEPIX_PAYMENT_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.BOLEPIX_PAYMENT_ERROR_CARD_MESSAGE,
  },
  [RoutesPath.PIX_ERROR]: {
    title: CONSTANTS_STRINGS.PIX_PAYMENT_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.PIX_PAYMENT_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.PIX_PAYMENT_ERROR_CARD_MESSAGE,
  },
  [RoutesPath.PIX_SUCCESS]: {
    title: CONSTANTS_STRINGS.PIX_PAYMENT_SUCCESS_TITLE,
    cardTitle: CONSTANTS_STRINGS.PIX_PAYMENT_SUCCESS_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.PIX_PAYMENT_SUCCESS_CARD_MESSAGE,
  },
  [RoutesPath.PRE_AUTHORIZATION_ERROR]: {
    title: CONSTANTS_STRINGS.PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
  REVERSED_FAILED: {
    title: CONSTANTS_STRINGS.REVERSED_FAILED_TITLE,
    cardTitle: CONSTANTS_STRINGS.REVERSED_FAILED_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.REVERSED_FAILED_CARD_MESSAGE,
  },
  [RoutesPath.DIRECT_DEBIT_SUCCESS]: {
    title: CONSTANTS_STRINGS.DIRECT_DEBIT_PAYMENT_SUCCESS_TITLE,
    cardTitle: CONSTANTS_STRINGS.DIRECT_DEBIT_PAYMENT_IN_PROGRESS,
    cardMessage: CONSTANTS_STRINGS.DIRECT_DEBIT_PRE_AUTHORIZATION_MESSAGE,
  },
  [RoutesPath.DIRECT_DEBIT_ERROR]: {
    title: CONSTANTS_STRINGS.DIRECT_DEBIT_PAYMENT_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.DIRECT_DEBIT_PAYMENT_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.DIRECT_DEBIT_PAYMENT_ERROR_CARD_MESSAGE,
  },
  [RoutesPath.PRE_AUTHORIZATION_WAITING]: {
    title: CONSTANTS_STRINGS.PRE_AUTHORIZATION_WAITING_TITLE,
    cardTitle: CONSTANTS_STRINGS.PRE_AUTHORIZATION_WAITING_SUBTITLE,
    cardMessage: CONSTANTS_STRINGS.PRE_AUTHORIZATION_WAITING_MESSAGE,
  },
  [RoutesPath.PRE_AUTHORIZED_BY_GATEWAY]: {
    title: CONSTANTS_STRINGS.PRE_AUTHORIZED_BY_GATEWAY_TITLE,
    cardTitle: CONSTANTS_STRINGS.PRE_AUTHORIZED_BY_GATEWAY_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.PRE_AUTHORIZED_BY_GATEWAY_CARD_MESSAGE,
  },
};

export const PRE_AUTH_ERROR_BY_METHOD: Record<string, FinalMessageType> = {
  [ApiPaymentMethods.PIX]: {
    title: CONSTANTS_STRINGS.PIX_PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.PIX_PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.PIX_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
  [ApiPaymentMethods.CREDIT_CARD]: {
    title: CONSTANTS_STRINGS.CREDIT_CARD_PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.CREDIT_CARD_PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage:
      CONSTANTS_STRINGS.CREDIT_CARD_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
  [ApiPaymentMethods.BANK_SLIP]: {
    title: CONSTANTS_STRINGS.BANK_SLIP_PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.BANK_SLIP_PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage:
      CONSTANTS_STRINGS.BANK_SLIP_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
  [ApiPaymentMethods.DIRECT_DEBIT]: {
    title: CONSTANTS_STRINGS.DIRECT_DEBIT_PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle:
      CONSTANTS_STRINGS.DIRECT_DEBIT_PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage:
      CONSTANTS_STRINGS.DIRECT_DEBIT_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
  [ApiPaymentMethods.BOLEPIX]: {
    title: CONSTANTS_STRINGS.BOLEPIX_PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle: CONSTANTS_STRINGS.BOLEPIX_PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage: CONSTANTS_STRINGS.BOLEPIX_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
  [ApiPaymentMethods.OPEN_FINANCE]: {
    title: CONSTANTS_STRINGS.OPEN_FINANCE_PRE_AUTHORIZATION_ERROR_TITLE,
    cardTitle:
      CONSTANTS_STRINGS.OPEN_FINANCE_PRE_AUTHORIZATION_ERROR_CARD_TITLE,
    cardMessage:
      CONSTANTS_STRINGS.OPEN_FINANCE_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE,
  },
};
